export default "/images/1a323c9a080e0e9c2c09fbb6506a9772.avif";